import { getApiBaseUrl } from './api';
import { ensureOk } from './httpError';

export interface SupportAnnouncement {
  id: string;
  title: string;
  body: string;
  category: string;
  pinned: boolean;
  is_visible: boolean;
  created_at: string;
  updated_at: string;
}

function authHeaders(token: string) {
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

export async function listAnnouncements(token: string): Promise<SupportAnnouncement[]> {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-announcements`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Falha ao carregar avisos');
  const data = await res.json();
  return data.announcements ?? [];
}

export async function createAnnouncement(
  token: string,
  payload: { title: string; body?: string; category?: string; pinned?: boolean },
): Promise<SupportAnnouncement> {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-announcements`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(payload),
  });
  await ensureOk(res, 'Falha ao criar aviso');
  const data = await res.json();
  return data.announcement;
}

export async function updateAnnouncement(
  token: string,
  id: string,
  payload: { title?: string; body?: string; category?: string; pinned?: boolean },
): Promise<SupportAnnouncement> {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-announcements/${id}`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: JSON.stringify(payload),
  });
  await ensureOk(res, 'Falha ao atualizar aviso');
  const data = await res.json();
  return data.announcement;
}

export async function toggleAnnouncementVisibility(token: string, id: string): Promise<SupportAnnouncement> {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-announcements/${id}/visibility`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Falha ao alterar visibilidade');
  const data = await res.json();
  return data.announcement;
}

export async function deleteAnnouncement(token: string, id: string): Promise<void> {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-announcements/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Falha ao excluir aviso');
}
